import { useTranslation } from "react-i18next";

export type Office = {
  key: string;
  tag: string;
  city: string;
  street: string;
  postal: string;
  phone: { label: string; href: string };
  /** Destino do "Como chegar" no Google Maps. */
  query: string;
  lngLat: [number, number];
};

// Escritórios da Calriz: fonte única do rodapé e da página /onde-estamos. A ordem define a numeração (01, 02):
// o primeiro é a matriz, de onde sai o arco do mapa. Endereço de SP igual ao dos dados fiscais da intranet.
const OFFICES_CONFIG = [
  {
    key: "sp",
    tag: "Matriz · Brasil",
    city: "São Paulo",
    street: "Av. Paulista, 2073 · Conj. Nacional, Horsa I, cj. 1301 e 1302 · Bela Vista",
    postal: "CEP 01311-940 · São Paulo – SP",
    phone: { label: "(11) 2394-7253", href: "tel:+551123947253" },
    query: "Av. Paulista, 2073 - Bela Vista, São Paulo - SP, 01311-940",
    lngLat: [-46.661249, -23.558729] as [number, number],
  },
  {
    key: "orlando",
    tag: "Escritório · EUA",
    city: "Orlando",
    street: "7345 W Sand Lake Rd, Ste 210, OFC 908",
    postal: "Orlando – FL 32819",
    phone: { label: "(304) 470-0005", href: "tel:+13044700005" },
    query: "7345 W Sand Lake Rd Ste 210, Orlando, FL 32819",
    lngLat: [-81.482655, 28.450964] as [number, number],
  },
];

export const MAP_PATH = "/onde-estamos";

/** Link "Ver no mapa" de um escritório: abre a página já focada nele, rolando até o mapa. */
export const officeMapLink = (index: number) => `${MAP_PATH}?u=${index}#mapa`;

export function useOffices(): Office[] {
  const { t } = useTranslation();

  return OFFICES_CONFIG.map((office) => ({
    ...office,
    tag: t(`offices.${office.key}_tag`, office.tag),
  }));
}
